import { useSelector } from "react-redux";
import clsx from 'clsx';
import { Link } from "react-router-dom";

import { formatHistoryDateTime } from "../../../utils/formatDate";

import IntegrationErrors from "../../../pages/easymerch/integrationErrors/integrationErrors";
import SectionContent from "../../../components/sectionContent/sectionContent";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { IUserOptions } from "../../../types/interfaces";

const IntegrationErrorsApp = () => {

  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);
  const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);


  const { lastUpdate } = useSelector(
    (state: any) => state.easymerch.integrationErrors
  );
  return (
    <div className="App">
      <Sidebar />
      <SectionContent
        section="Easy Merch"
        title="Ошибки интеграции"
        headBlockChildren={
          <>
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <HeaderBtn
              content="Выгрузка ошибок интеграции"
              purpose="errorsUnload"
              modalTitle="Выгрузка ошибок интеграции"
              hasIcon='excel'
            />}

            {(claims.includes('admin') ||
							claims.includes('reports:import:em')) && <HeaderBtn
              content="Создание отчетов"
              purpose="createReports"
              modalTitle="Загрузить данные отчетов"
            />}
          </>
        }
      >
        <div className="content__main">
          <div className={clsx(
						isOpenSidebar &&
						"btns_active",
						!isOpenSidebar && "btns_close",
						'btns'
					)}>
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/outlets" className="tab">
              <div className="buttons__btn">Торговые точки</div>
            </Link>}
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/report" className="tab">
              <div className="buttons__btn">Типы отчетов</div>
            </Link>}
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/users" className="tab">
              <div className="buttons__btn">Физ. лица</div>
            </Link>}
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/service-types" className="tab">
              <div className="buttons__btn">Типы обслуживания</div>
            </Link>}
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/integration-errors" className="tab">
              <div className="buttons__btn --active">Ошибки интеграции</div>
            </Link>}
            {lastUpdate && (
              <div className="last__update_block">
                <span>
                  Последнее обновление: {formatHistoryDateTime(lastUpdate)}
                </span>
              </div>
            )}
          </div>
          <IntegrationErrors />
        </div>
      </SectionContent>
    </div>
  );
};

export default IntegrationErrorsApp;
